import { getTheme } from "./themes";
import styled from "@emotion/styled";
export const TypographyStyled = styled.span `
  ${(props) => getTheme(props.$variant, props.$family, props.$bold, props.$italic, props.$color)}
`;
//# sourceMappingURL=Typography.styled.js.map